import React, { useEffect } from "react";
import { logDebug } from "../../../shared/common/logger";

const AddressCompletion: React.FC<{
	className?: string;
	placeholder: string;
	value: string;
	onChange: (v: string) => void;
	onComplete: (v: string, addressComponents?: any) => void;
}> = ({ onComplete, placeholder, value, onChange, className }) => {
	const inputRef = React.useRef<HTMLInputElement>(null);
	const autoCompleteRef = React.useRef<any>(null);
	useEffect(() => {
		if (autoCompleteRef.current) {
			return;
		}
		//@ts-ignore
		autoCompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, { types: ["geocode"] });
		//@ts-ignore
		google.maps.event.addListener(autoCompleteRef.current, "place_changed", onPlaceChanged);
	}, []);

	function onPlaceChanged(e: any) {
		const place = autoCompleteRef.current.getPlace();
		onChange(place.formatted_address);
		onComplete(place.formatted_address, place.address_components);
	}

	return (
		<input
			onBlur={() => !value && onComplete("", undefined)}
			ref={inputRef}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			className={className || ""}
			type="text"
			placeholder={placeholder}
		/>
	);
};

export default AddressCompletion;
